var symphony = symphony || {};

;(function() {

	symphony.geolocate = function(options, completed) {

		var $locateTrigger = $('.js-geolocate');

		function geoLocate(){ 
			var deferred = $.Deferred();
		
			var options;
			navigator.geolocation.getCurrentPosition(deferred.resolve, deferred.reject, options);
		
			return deferred.promise();
		}

		function extractFromAdress(components, type){
			for (var i=0; i<components.length; i++)
				for (var j=0; j<components[i].types.length; j++)
					if (components[i].types[j]==type) return components[i].long_name;
					return "";
		}

		$locateTrigger.click(function(e){

			var input = $(this).parent().find('#zip');
			var icon = $(this).find('.fa');
			var className = icon.attr('class');

			icon.attr('class', 'fa fa-spinner u-rotate');

			geoLocate({
				enableHighAccuracy: true
			}).done(function(pos) {
				symphony.config.latLong = [pos.coords.latitude,pos.coords.longitude];
				var getZip = $.get('//maps.googleapis.com/maps/api/geocode/json?latlng=' + pos.coords.latitude + ',' + pos.coords.longitude);
				getZip.done(function(data){
					var postCode = extractFromAdress(data.results[0].address_components, "postal_code");
					if(postCode !== ""){
						input.val(postCode);
					}
				});
				
				//symphony.gdosSearchResults();
			}).fail(function(err) {
				$('.results').html('<p>Sorry! There was an error. Please try again or use the manual zip search feature. The error was' + err.code + ' ' + err.message);
			}).always(function() {
				icon.attr('class', className);
			});

		});

	};

})();